export const statusSelector = (state) => state.status;
